import { render, staticRenderFns } from "./detail-dict-value.vue?vue&type=template&id=bd66c5c6&scoped=true"
import script from "./detail-dict-value.vue?vue&type=script&lang=js"
export * from "./detail-dict-value.vue?vue&type=script&lang=js"
import style0 from "./detail-dict-value.vue?vue&type=style&index=0&id=bd66c5c6&prod&lang=scss&scoped=true"
import style1 from "./detail-dict-value.vue?vue&type=style&index=1&id=bd66c5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd66c5c6",
  null
  
)

export default component.exports